import React from 'react';
import classes from "./input.module.sass";

const Input = ({placeholder, ...props}) => {
    return (
        <input className={classes.input} {...props} placeholder={placeholder}/>
    );
};

export default Input;